module.exports = __webpack_public_path__ + "img/logo.0ad55b06.png";